import Head from 'next/head';
import { type AppProps } from 'next/app';

import GrowthBookWrapper from '@macpaw/growthbook-next-cloudflare-pages-integration/pages/GrowthBookWrapper';
import experimentsConfig from 'gb-next-cf.config';
import ErrorBoundary from '@/components/error/ErrorBoundary';
import AnalyticsEventHandler from '@/services/analytics/AnalyticsEventHandler';

import Fonts from '@/components/layout/Fonts';
import '@fontsource-variable/montserrat';
import '@/styles/index.scss';

const App = ({ Component, pageProps, router }: AppProps) => {
  const { pathname } = router;

  let pathNormalized = pathname;

  if (pathname.includes('_ab-tests')) {
    pathNormalized = pathNormalized.replace('_ab-tests/', '').replace(/\/variant-([a-z]{1})/, '');
  }

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width,initial-scale=1.0" />
        <link rel="canonical" href={`https://order.clearvpn.com${pathNormalized.length > 1 ? pathNormalized : ''}/`} />
        <Fonts />
      </Head>
      <ErrorBoundary>
        <GrowthBookWrapper
          experiments={experimentsConfig.experiments}
          trackingCallback={(experiment, result) => {
            console.log(experiment);
            console.log(result);
            AnalyticsEventHandler.trackGrowthBookTestResult(result.value);
          }}
        >
          <Component {...pageProps} />
        </GrowthBookWrapper>
      </ErrorBoundary>
    </>
  );
};

export default App;
